import i18next from '../../../strings/i18n/i18n';
import { AlertIDType } from '../../../const/alertsConfig';
var deliveryMethodError = "".concat(i18next.t('errorMessages.deliveryMethod'));
var amountError = "".concat(i18next.t('errorMessages.amountTextField'));
export var getDataChannels = function (deliveryMethodLabels, keyword) {
    if (deliveryMethodLabels.length <= 0) {
        return '';
    }
    if (deliveryMethodLabels.length <= 1) {
        return "".concat(keyword, ": ").concat(deliveryMethodLabels.join(''), " only");
    }
    return "".concat(keyword, ": ").concat(deliveryMethodLabels.join(' and '));
};
export var getSelectedTransactionOption = function (alertId, value) {
    var selectedTransactionOption;
    if (alertId === AlertIDType.APPROVED_TRANSACTIONS) {
        switch (value) {
            case AlertIDType.PURCHASE_EXCEEDS:
                selectedTransactionOption =
                    'For approved transactions over a specified amount';
                break;
            case AlertIDType.TRANSACTION_AUTHORIZATION:
                selectedTransactionOption = 'For all approved transactions';
                break;
            default:
                selectedTransactionOption = '';
        }
        return selectedTransactionOption;
    }
    return '';
};
export var getAprrovedTransactionDataMessage = function (purchaseExceedsDataError, approvedTransactionsDataError) {
    var mergedArray = [].concat(purchaseExceedsDataError, approvedTransactionsDataError);
    var uniqueDataErrors = mergedArray === null || mergedArray === void 0 ? void 0 : mergedArray.reduce(function (unique, o) {
        if (!unique.some(function (obj) {
            return (obj === null || obj === void 0 ? void 0 : obj.key) === (o === null || o === void 0 ? void 0 : o.key) && (obj === null || obj === void 0 ? void 0 : obj.value) === (o === null || o === void 0 ? void 0 : o.value);
        })) {
            unique.push(o);
        }
        return unique;
    }, []);
    var dataErrorKeys = uniqueDataErrors === null || uniqueDataErrors === void 0 ? void 0 : uniqueDataErrors.map(function (o) { return o === null || o === void 0 ? void 0 : o.key; });
    if (dataErrorKeys.includes('purchaseExceedsThresholdAmount') &&
        dataErrorKeys.includes('delivery')) {
        return "".concat(amountError, " | ").concat(deliveryMethodError);
    }
    if (dataErrorKeys.includes('purchaseExceedsThresholdAmount') &&
        !dataErrorKeys.includes('delivery')) {
        return "".concat(amountError);
    }
    if (!dataErrorKeys.includes('purchaseExceedsThresholdAmount') &&
        dataErrorKeys.includes('delivery')) {
        return "".concat(deliveryMethodError);
    }
    return '';
};
export var isrelevantlyDirty = function (alertId, hasPurchaseExceedsValue, isPurchaseExceedAlertDirty, isDirty) {
    if (alertId !== AlertIDType.APPROVED_TRANSACTIONS) {
        return isDirty;
    }
    return hasPurchaseExceedsValue ? isPurchaseExceedAlertDirty : isDirty;
};
export var getDataMessage = function (isApprovedTransactionAlert, hasPurchaseExceedsValue, transactionMessage, dataMessage) {
    if (!isApprovedTransactionAlert) {
        return dataMessage;
    }
    return hasPurchaseExceedsValue ? transactionMessage : dataMessage;
};
export var getDataAttributes = function (hasSelectedText, hasSmsConsent, defaultDataAttributes, dataAttributesWithConsent) {
    if (hasSmsConsent) {
        return dataAttributesWithConsent;
    }
    return hasSelectedText ? defaultDataAttributes : dataAttributesWithConsent;
};
